<template>
    <vue-modal :name="name" :hideCloseBtn="true" style="z-index: 10000"> <!-- :on-show="changeForm()" -->
        <div class="card" style="border: none; margin-bottom: 0;">
            <div class="card-header" style="border-bottom: none; padding: 1rem 0px;">
                <h3 class="form-section" v-if="!photo">
                    <span @click="barcodeShow = !barcodeShow; manualBar = !manualBar;" class="hand"><i :class="[barcodeShow ? 'icon-barcode' : 'icon-qrcode']"></i></span> 
                    <span v-if="!barcodeShow" @click="showErrors()">QR code</span>
                    <span v-if="barcodeShow" @click="showErrors()">BARcode</span> <i v-if="destroyed_cam"> - Not Allowed</i>
                </h3>
                <h3 class="form-section" v-if="photo">
                    <i class="icon-camera8"></i> <span @click="showErrors()">Camera</span> <i v-if="destroyed_cam"> - Not Allowed</i>
                </h3>
                <div class="heading-elements" style="right: 0px;">
                    <button type="button" ref="closeModal" class="btn btn-warning" @click="closingModal(); $modals.hide('QrCode');">
                        <i style="color: #FFFFFF" class="icon-cross"></i>
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-12">
                        <!-- <p v-if="noFrontCamera">You don't seem to have a front camera on your device</p>
                        <p v-if="noRearCamera">You don't seem to have a rear camera on your device</p> -->
                        
                        <div class="row">
                            <StreamBarcodeReader v-if="!destroyed_cam && barcodeShow && !notAllowed" @decode="DecodeBar" @loaded="LoadedBar"></StreamBarcodeReader>
                            <div class="" v-if="!notAllowed">
                                <qrcode-stream class="w-100" :track="true" :camera="camera" :torch="torchActive" @decode="onDecode" @init="onInit" v-if="!destroyed_cam && !barcodeShow" >
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <button type="button" class="btn btn-warning" @click="switchCamera">
                                                <i class="icon-loop22"></i>
                                            </button>
                                        </div>
                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-danger" @click="reloadcam">
                                                <i class="icon-switch"></i>
                                            </button>
                                        </div>
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" @click="torchActive = !torchActive" :disabled="torchNotSupported">
                                                <i class="icon-sun"></i>
                                            </button>
                                        </div>
                                        
                                    </div>
                                    <div class="card-block text-xs-center" v-show="cam_loading">
                                        <div class="mt-2"><i class="icon-gear-a spinner font-large-2"></i></div>
                                    </div>
                                </qrcode-stream>
                            </div>
                            <div class="d-flex justify-content-center" v-if="notAllowed">
                                <div class="text-xs-center">
                                    <h1><i class="icon-camera6"></i></h1>
                                    <h3>{{ $t('errors.permission')}}</h3>
                                    <p>{{ $t('errors.permСamera')}}.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-1" v-if="!barcodeShow">
                    <div class="col-md-12" v-if="(destroyed_cam || manual) && !photo">
                        <div class="input-group">
                            <div class="input-group-prepend" v-if="manual_btn">
                                <button type="button" class="btn btn-warning" @click="destroyed_cam = false; manual_btn = false">
                                    <i class="icon-qrcode"></i> activate
                                </button>
                            </div>
                            <div class="input-group-prepend" v-if="!manual_btn">
                                <button type="button" class="btn btn-warning" @click="destroyed_cam = true; manual_btn = true">
                                    <i class="icon-qrcode"></i> deactivate
                                </button>
                            </div>
                            <input class="form-control border-primary" tabindex="100" type="text" id="seriale" v-model="manualInput" @keyup.enter="manualInp()">
                            
                            <div class="input-group-append">
                                <button type="button" class="btn btn-primary btn-round" @click="manualInp();">
                                    <a style="color: white"><i class="icon-floppy-disk"></i></a>
                                </button>
                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="d-flex justify-content-center" v-if="photo">
                            <button type="button" class="btn btn-warning" style="width: 40%" @click="takePhoto()">
                                <h3><i class="icon-camera8"></i></h3>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </vue-modal>
</template>

<script>
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader';
import { StreamBarcodeReader  } from "vue-barcode-reader";
  
  export default {
    name: "QrCode",
    data(){
        return {
            camera: 'auto',

            barcodeShow: false,
            manual_btn: true,
            resultQR: null,
            cam_loading: false,
            destroyed_cam: false,
            //features of cameras
            noRearCamera: false,
            noFrontCamera: false,
            torchActive: false,
            torchNotSupported: false,

            manualInput: null,

            notAllowed: false,

            manualBar: false,
        }
    },
    components: { QrcodeStream, QrcodeDropZone, QrcodeCapture, StreamBarcodeReader },
    props:{
        qr_func: {type: Function, required: false},//delete
        cam_func: {type: Function, required: false},//delete

        //options of modes
        name: {type: String, required: true},
        manual: {type: Boolean, required: false, default: false},
        photo: {type: Boolean, required: false, default: false},
        barCode: {type: Boolean, required: false, default: false},

        serialME: {type: Boolean, required: false, default: true},
        //options of modes

    },
    emits: ['onQr', 'onBarcode', 'onPhoto', 'onClose'],
    methods:{
        changeForm(){
            //document.getElementsByClassName('v-modal__heading').style.padding = '0px';
            // setTimeout( () => {
            //         $('.v-modal__heading').css({"padding":"0px"});
            //     },500 
            // );
        },
        closingModal(){
            this.manual_btn = false;
            this.manualInput = null;
            this.resultQR = null;
            this.cam_loading = false;
            this.destroyed_cam = false;
            this.barcodeShow = false;
            //features of cameras
            this.noRearCamera = false;
            this.noFrontCamera = false;
            this.torchActive = false;
            this.torchNotSupported = false;
            this.$store.state.active_qr = false;
            this.$store.commit('setCamera', false );
            this.$emit('onClose', {});
        },
        async onInit (promise) {
            this.notAllowed = false;
            this.cam_loading = true;
            this.manual_btn = false;

            if(this.manual && (!this.photo)){
                document.getElementById("seriale").focus();
            }

            try {
                //await promise
                const { capabilities } = await promise

                if(this.barCode){ this.destroyed_cam = false; this.barcodeShow = true; }
                if(this.manualBar){ this.destroyed_cam = false; this.barcodeShow = true;}

                this.torchNotSupported = !capabilities.torch
            } catch (error) {

                this.addError('Camera', error);

                if (error.name === 'NotAllowedError') {
                    // user denied camera access permisson
                    this.destroyed_cam = true;
                } else if (error.name === 'NotFoundError') {
                    // no suitable camera device installed
                    this.destroyed_cam = true;
                } else if (error.name === 'NotSupportedError') {
                    // page is not served over HTTPS (or localhost)
                    this.destroyed_cam = true;
                } else if (error.name === 'NotReadableError') {
                    // maybe camera is already in use
                    this.destroyed_cam = true;
                } else if (error.name === 'OverconstrainedError') {
                    // did you requested the front camera although there is none?
                } else if (error.name === 'StreamApiNotSupportedError') {
                    // browser seems to be lacking features
                    this.destroyed_cam = true;
                }

                const triedFrontCamera = this.camera === 'front'
                const triedRearCamera = this.camera === 'rear'
                const cameraMissingError = error.name === 'OverconstrainedError'
                if (triedRearCamera && cameraMissingError) {
                    this.noRearCamera = true;
                }
                if (triedFrontCamera && cameraMissingError) {
                    this.noFrontCamera = true;
                }
                this.manual_btn = true;
                this.notAllowed = true;
                console.error(error);
            } finally {
                this.cam_loading = false;
                $('.v-modal__heading').css({"padding":"0px"});
                $('.qrcode-stream-camera').css({"min-height":"80vh"}).css({"max-height":"80vh"});
                $('.qrcode-stream-camera').css({"min-height":"80vh"}).css({"max-height":"80vh"}).css({"object-fit":"contain"});
                $('.qrcode-stream-overlay').css({"min-height":"80vh"}).css({"max-height":"80vh"});
                //style="min-height: 50vh; max-height: "
            }
        },
        turnCameraOn () { this.camera = 'auto' },
        turnCameraOff () { this.camera = 'off' },
        timeout (ms) {
            return new Promise(resolve => { window.setTimeout(resolve, ms) })
        },
        async reloadcam () {
            this.destroyed_cam = true;
            await this.$nextTick();
            this.destroyed_cam = false;
        },
        switchCamera () {
            switch (this.camera) {
                case 'auto': this.camera = 'rear'
                break
                case 'front': this.camera = 'auto'
                break
                case 'rear': this.camera = 'front'
                break
                
            }
        },
        onDecode (result) {
            let res = result.trim();

            if (!this.photo && !this.barCode){
                this.checkBarQRtext(res)
                .then(result => {
                    this.$emit('onQr', result);
                    this.$refs.closeModal.click();
                })
                .catch(err => {
                    this.showNotification('custom-error',this.$t('errors.title'), this.$t('errors.wrongSerial') );
                    console.log(err)
                });
            }
            
        },
        manualInp(){
            let ser = (this.manualInput).trim();

            this.checkBarQRtext(ser)
            .then(result => {
                if(this.barCode){
                    this.$emit('onBarcode', result);
                } else {
                    this.$emit('onQr', result);
                }
                this.$refs.closeModal.click();
            })
            .catch(err => {
                this.showNotification('custom-error',this.$t('errors.title'), this.$t('errors.wrongSerial') );
                console.log(err)
            });
        },
        takePhoto(){
            if(this.destroyed_cam){
                this.destroyed_cam = !this.destroyed_cam;
                return
            }
            let videoEl = null, canvasEl = null;
            videoEl = $('video.qrcode-stream-camera');
            canvasEl = $('canvas.qrcode-stream-camera');

            if((videoEl[0] != undefined) && (canvasEl[0] != undefined)){
                canvasEl[0].width = videoEl[0].videoWidth;
                canvasEl[0].height = videoEl[0].videoHeight;
                $('canvas.qrcode-stream-camera').css({"display":"block"});
                const context = canvasEl[0].getContext('2d');
                context.drawImage(videoEl[0], 0, 0, videoEl[0].videoWidth, videoEl[0].videoHeight);
                let resultCam = canvasEl[0].toDataURL("image/png");
                if (this.isValid(resultCam)){
                    //this.cam_func(resultCam);

                    this.$emit('onPhoto', resultCam);
                }
            }
            this.$refs.closeModal.click();
            
        },
        checkBarQRtext: function(data){
            return new Promise((resolve, reject) => {

                if(data.indexOf('test') > -1){
                    return resolve(data);
                }

                if(this.serialME){
                    if(data.indexOf('-') < 0){
                        return reject(data)
                    }
                    let last4str = data.substring( (data.length) - 5 , (data.length) );
                    let digits = /^[0-9]+$/.test(last4str);//last4str.match(/\D/) == null;
                    if(!digits){
                        return reject(data)
                    }

                    if (data.indexOf('http') > -1){
                        data = data.substring( data.indexOf('/product/') + 9 , (data.length) );
                    }
                    
                    if(data.indexOf('se-') < 0){
                        data = 'ме-' + data.split('-')[1];
                    }
                }
                return resolve(data);
            });
        },
        DecodeBar (result) {
            let res = result.trim();

            this.$emit('onBarcode', res);

            this.$refs.closeModal.click();            
        },
        LoadedBar(){
            $('.v-modal__heading').css({"padding":"0px"});
            //if(!this.barCode && !this.manualBar){ this.barcodeShow = false;}
        },

        
    },
    computed: {},
    mounted(){
        if ( this.manual && (this.photo == false)){
            //this.destroyed_cam = true;
            this.manual_btn = true;
        }
        
    },
    watch:{
        /*barcodeShow: function(newVal, oldVal){
            if (newVal && !oldVal){
                this.cam_loading = false;
            } else if(!newVal && oldVal){
                this.cam_loading = true;
            }
        },*/
    },
    created(){
        
    },
  }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Camera.vue